export const CollectionEvents = {
  FilterUpdate: 'collection:filter-update',
} as const;
